/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks Country Codes API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface CountryCode {
    'id'?: string;
    /**
     * Country name
     */
    'name': string;
    /**
     * Country code (e.g., DE, EN)
     */
    'code': string;
    /**
     * Currency code (e.g., EUR, USD)
     */
    'currency'?: string;
}
export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
export interface UploadCountryCodesCsv200Response {
    /**
     * Number of records inserted
     */
    'inserted': number;
    /**
     * Number of existing records deleted before insertion
     */
    'deleted': number;
}

/**
 * CountryCodesApi - axios parameter creator
 */
export const CountryCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCountryCode: async (countryCode: CountryCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('createCountryCode', 'countryCode', countryCode)
            const localVarPath = `/api/country-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countryCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a country code
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCountryCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCountryCode', 'id', id)
            const localVarPath = `/api/country-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a country code by ID
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCountryCode', 'id', id)
            const localVarPath = `/api/country-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all country codes. Client-side filtering and sorting are handled in the frontend table. 
         * @summary List country codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountryCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/country-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a country code
         * @param {string} id Unique identifier of the country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountryCode: async (id: string, countryCode: CountryCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCountryCode', 'id', id)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('updateCountryCode', 'countryCode', countryCode)
            const localVarPath = `/api/country-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countryCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads country codes from a CSV file. This operation deletes all existing country codes  and replaces them with the data from the uploaded file.  **CSV Format Requirements:** - Must include a header row - Character encoding: UTF-8 - Delimiter: comma (,) - Empty lines are automatically ignored - Whitespace is trimmed from all values  **Required Columns:** - `name` - Country name (cannot be blank) - `code` - Country code, e.g., DE, US, GB (cannot be blank)  **Optional Columns:** - `currency` - Currency code, e.g., EUR, USD, GBP  **Example CSV:** ``` name,code,currency Germany,DE,EUR United States,US,USD United Kingdom,GB,GBP Norway,NO,NOK ```  **Validation:** - CSV must contain a valid header row with at least \'name\' and \'code\' columns - Name and code fields cannot be blank - Invalid rows will cause the entire upload to fail with a 400 error 
         * @summary Upload country codes from CSV file
         * @param {File} file CSV file with country code data. Must be a valid CSV file with headers. See operation description for detailed format requirements. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCountryCodesCsv: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadCountryCodesCsv', 'file', file)
            const localVarPath = `/api/country-codes/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountryCodesApi - functional programming interface
 */
export const CountryCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountryCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCountryCode(countryCode: CountryCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCountryCode(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.createCountryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a country code
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCountryCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCountryCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.deleteCountryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a country code by ID
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountryCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountryCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.getCountryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all country codes. Client-side filtering and sorting are handled in the frontend table. 
         * @summary List country codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCountryCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryCode>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCountryCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.listCountryCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a country code
         * @param {string} id Unique identifier of the country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCountryCode(id: string, countryCode: CountryCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCountryCode(id, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.updateCountryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads country codes from a CSV file. This operation deletes all existing country codes  and replaces them with the data from the uploaded file.  **CSV Format Requirements:** - Must include a header row - Character encoding: UTF-8 - Delimiter: comma (,) - Empty lines are automatically ignored - Whitespace is trimmed from all values  **Required Columns:** - `name` - Country name (cannot be blank) - `code` - Country code, e.g., DE, US, GB (cannot be blank)  **Optional Columns:** - `currency` - Currency code, e.g., EUR, USD, GBP  **Example CSV:** ``` name,code,currency Germany,DE,EUR United States,US,USD United Kingdom,GB,GBP Norway,NO,NOK ```  **Validation:** - CSV must contain a valid header row with at least \'name\' and \'code\' columns - Name and code fields cannot be blank - Invalid rows will cause the entire upload to fail with a 400 error 
         * @summary Upload country codes from CSV file
         * @param {File} file CSV file with country code data. Must be a valid CSV file with headers. See operation description for detailed format requirements. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCountryCodesCsv(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadCountryCodesCsv200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCountryCodesCsv(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryCodesApi.uploadCountryCodesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CountryCodesApi - factory interface
 */
export const CountryCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountryCodesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCountryCode(countryCode: CountryCode, options?: RawAxiosRequestConfig): AxiosPromise<CountryCode> {
            return localVarFp.createCountryCode(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a country code
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCountryCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCountryCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a country code by ID
         * @param {string} id Unique identifier of the country code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCode(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CountryCode> {
            return localVarFp.getCountryCode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all country codes. Client-side filtering and sorting are handled in the frontend table. 
         * @summary List country codes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountryCodes(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryCode>> {
            return localVarFp.listCountryCodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a country code
         * @param {string} id Unique identifier of the country code
         * @param {CountryCode} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountryCode(id: string, countryCode: CountryCode, options?: RawAxiosRequestConfig): AxiosPromise<CountryCode> {
            return localVarFp.updateCountryCode(id, countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads country codes from a CSV file. This operation deletes all existing country codes  and replaces them with the data from the uploaded file.  **CSV Format Requirements:** - Must include a header row - Character encoding: UTF-8 - Delimiter: comma (,) - Empty lines are automatically ignored - Whitespace is trimmed from all values  **Required Columns:** - `name` - Country name (cannot be blank) - `code` - Country code, e.g., DE, US, GB (cannot be blank)  **Optional Columns:** - `currency` - Currency code, e.g., EUR, USD, GBP  **Example CSV:** ``` name,code,currency Germany,DE,EUR United States,US,USD United Kingdom,GB,GBP Norway,NO,NOK ```  **Validation:** - CSV must contain a valid header row with at least \'name\' and \'code\' columns - Name and code fields cannot be blank - Invalid rows will cause the entire upload to fail with a 400 error 
         * @summary Upload country codes from CSV file
         * @param {File} file CSV file with country code data. Must be a valid CSV file with headers. See operation description for detailed format requirements. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCountryCodesCsv(file: File, options?: RawAxiosRequestConfig): AxiosPromise<UploadCountryCodesCsv200Response> {
            return localVarFp.uploadCountryCodesCsv(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountryCodesApi - object-oriented interface
 */
export class CountryCodesApi extends BaseAPI {
    /**
     * 
     * @summary Create a country code
     * @param {CountryCode} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCountryCode(countryCode: CountryCode, options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).createCountryCode(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a country code
     * @param {string} id Unique identifier of the country code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCountryCode(id: string, options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).deleteCountryCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a country code by ID
     * @param {string} id Unique identifier of the country code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCountryCode(id: string, options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).getCountryCode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all country codes. Client-side filtering and sorting are handled in the frontend table. 
     * @summary List country codes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCountryCodes(options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).listCountryCodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a country code
     * @param {string} id Unique identifier of the country code
     * @param {CountryCode} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCountryCode(id: string, countryCode: CountryCode, options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).updateCountryCode(id, countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads country codes from a CSV file. This operation deletes all existing country codes  and replaces them with the data from the uploaded file.  **CSV Format Requirements:** - Must include a header row - Character encoding: UTF-8 - Delimiter: comma (,) - Empty lines are automatically ignored - Whitespace is trimmed from all values  **Required Columns:** - `name` - Country name (cannot be blank) - `code` - Country code, e.g., DE, US, GB (cannot be blank)  **Optional Columns:** - `currency` - Currency code, e.g., EUR, USD, GBP  **Example CSV:** ``` name,code,currency Germany,DE,EUR United States,US,USD United Kingdom,GB,GBP Norway,NO,NOK ```  **Validation:** - CSV must contain a valid header row with at least \'name\' and \'code\' columns - Name and code fields cannot be blank - Invalid rows will cause the entire upload to fail with a 400 error 
     * @summary Upload country codes from CSV file
     * @param {File} file CSV file with country code data. Must be a valid CSV file with headers. See operation description for detailed format requirements. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadCountryCodesCsv(file: File, options?: RawAxiosRequestConfig) {
        return CountryCodesApiFp(this.configuration).uploadCountryCodesCsv(file, options).then((request) => request(this.axios, this.basePath));
    }
}



